import { useEffect } from "react";
import { useLenis } from "./lib";
import { AmatHeader, AmatHero } from "./Chrome";
import { HighlightsSection } from "./Highlights";
import { PeopleSection } from "./People";
import { PlanetSection } from "./Planet";
import { DisclosuresSection } from "./Disclosures";
import { AskReport } from "./AskReport";
import { ProposalLink } from "./ProposalLink";
import { IMG, PDF } from "./content";
import "./amat.css";

function AmatFooter() {
  return (
    <footer className="bg-[var(--am-blue)] text-white" data-testid="am-footer">
      <div className="mx-auto flex max-w-[1320px] flex-col gap-8 px-5 py-14 sm:px-8 md:flex-row md:items-end md:justify-between">
        <div>
          <img src={IMG("logo-white.png")} alt="Applied Materials" className="h-10 w-auto" />
          <p className="mt-6 max-w-xl text-sm text-white/90">
            Sample web edition showing four sections of the Applied Materials 2025 Impact Report. All text, figures and images come from the published PDF. Status, assurance and footnotes are as stated in the report.
          </p>
        </div>
        <div className="flex flex-col items-start gap-3 md:items-end">
          <a href={PDF} target="_blank" rel="noreferrer" data-testid="am-footer-pdf" className="rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[var(--am-blue)] transition-colors hover:bg-[var(--am-yellow)]">
            Read the full 2025 Impact Report (PDF)<span className="sr-only"> (opens in a new tab)</span>
          </a>
          <ProposalLink />
          <p className="text-xs text-white/80">Example build by Big Pivot Partners</p>
        </div>
      </div>
    </footer>
  );
}

export default function AmatPage() {
  useLenis();
  useEffect(() => {
    const prev = document.title;
    document.title = "Applied Materials 2025 Impact Report · Web edition (example)";
    return () => { document.title = prev; };
  }, []);
  return (
    <div className="amat min-h-screen" data-testid="am-page">
      <AmatHeader />
      <main>
        <AmatHero />
        <HighlightsSection />
        <PeopleSection />
        <PlanetSection />
        <DisclosuresSection />
      </main>
      <AmatFooter />
      <AskReport />
    </div>
  );
}
